import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pzsmxvxzjh: FaireBrandEntity = {
  token: "b_pzsmxvxzjh",
  type: "brand",
  name: "Brass Earth",
  avatarUrl:
    "https://cdn.faire.com/fastly/30f22ec821f9fe4d9fdbf3800bff5f4d5111535218dc631365eeb35e2ac543e2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e4d814031c97832a445d5272b8f30ff96aa84408e0cb200cb58cc2ed8fab0c7b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/30f22ec821f9fe4d9fdbf3800bff5f4d5111535218dc631365eeb35e2ac543e2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e4d814031c97832a445d5272b8f30ff96aa84408e0cb200cb58cc2ed8fab0c7b.png",
  location: "Columbus, OH, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "The Brass Hand is a woman-owned plant, art, and gift shop in Columbus, Ohio.. a cozy, funky, creative space built around beautiful and slightly weird things for everyday life. Brass Earth grew out of that shop as our in-house line of fragrance, home décor, plant care, and art objects.\n\nFragrance is at the heart of the collection. Each scent is carefully crafted from memories from my own life, and every fragrance product is handmade by me, Heather — the owner behind both The Brass Hand and Brass Earth.\n\nWe create small-batch incense and scents designed to transform a room.. grounding, atmospheric, meant to transport! I deeply value creating high quality goods and providing immersive and warm customer experiences both in my brick and mortar shop and here on Faire! I'm always here if you have questions, a special request, or feedback!\n\nWe are committed to donating 1% of all Brass Earth profits to local mutual aids that support our community members in need.\n♥ Follow along @the.brass.hand",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:11.869Z",
    importedBy: "entity-db-cli",
  },
};
